import { createAction, Action, handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { debug } from '../../../utils';
import { postReviews, fetchPlace, fetchPlaces } from './actions';
// import actions from './actions';

import keyBy from 'lodash/keyBy';
import mergeWith from 'lodash/mergeWith';
import union from 'lodash/union';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

interface AspectReview {
    id: number;
    aspect: number;
    username: string;
    trained_rater: boolean;
    rating: number;
    comment: string;
    edited: string; // ? timestamp
    submitted: string; // ? timestamp
    flagged: boolean;
    meta: {
        rated: boolean;
        rating: number;
        rating_count: number;
    };
}

interface AspectReviews { [aspectID: number]: AspectReview[]; }
interface MyReviews { [aspectID: number]: AspectReview; }
interface PlaceReviews { [placeID: number]: AspectReviews; }

interface PlaceFuture {
	id: number;
	data: Place;
	inProgress: boolean;
}

interface Place {
    id: number;
    name: string;
    location: {
        position: { latitude: number, longitude: number };
        address: string;
    },
    arb: {
        rating: {
            average: number;
            personalized: number;
        },
        comments: number;
        review_count: number;
        reviewer_count: number;
        reviews: PlaceReviews;
        my_reviews: MyReviews;
    }// ,
        // google: {
        //     icon: google.icon,
        //     rating: google.rating,
        //     phone: "(414)-229-6803",
        //     website: "http://google.com"
        // }
}

interface PlaceFutureMap { [id: string]: PlaceFuture; };
interface PlaceReducers { [actionType: string]: {(state: PlaceFutureMap, action: Action<any>): PlaceFutureMap };}
const _PlaceReducers: PlaceReducers = {
  [fetchPlaces.names.COMPLETED]: (state, action) => {
    const { places } = action.payload;
    const places_map = keyBy(places.map(place => ({id: place.id, data: place, inProgress: false})), 'data.id') as any;

    return {...state, ...places_map};
    },
  [fetchPlace.names.START]: (state, action) => {
		const id = action.payload.id
			const place = {
				...(state[id] || {}),
				id,
				inProgress: true,
			}
      return {...state, [id]: place};
    },
  [fetchPlace.names.COMPLETED]: (state, action) => {
		const id = action.payload.id
      const place = {
				id: id,
				inProgress: false,
				data: mergeWith(get(state[id], 'data'), action.payload)
			}
      return {...state, [id]: place};
    },
    [postReviews.names.COMPLETED]: (state, action) => {
      // Update our copy of the place to include our reviews
      const { id, ...reviews } = action.payload;
      const place = {
				id,
				inProgress: false,
				data: {...state[id].data},
			};
        //if (!place) return state; // TODO: Warn? If the place doesn't exist there are other problems
        if (isEmpty(place.data.arb.my_reviews)) {
            place.data.arb.reviewer_count = (place.data.arb.reviewer_count || 0) + 1;
        }
        place.data.arb.my_reviews = reviews;

        return {...state, [id]: place};
    }
};

const initialState = {};
const PlaceReducers = handleActions<PlaceFutureMap>(_PlaceReducers, initialState as PlaceFutureMap);

export default {
    places: PlaceReducers
};



// WEBPACK FOOTER //
// ./src/app/models/Places/reducers.ts